export const colors = {
    background: "#1c0c3f",
    details: "#3bd42d",
    subtitles: "#a191ff",
    button: "#25cbd3",
    color: "#fff"
}